import CryptoJS from 'crypto-js';

export const generateRandomCryptographicId = (byteSize = 16) => {
  return CryptoJS.lib.WordArray.random(byteSize).toString();
};
